import BaseParameterAction from './BaseParameterAction.js';

class MoveAutomationBreakPointAction extends BaseParameterAction {
    execute({automation, point, step, value}) {
        automation.movePoint(point, step, value);
    }

    undo({payload}) {
        this.execute({
            ... payload,
            step: payload.savedStep,
            value: payload.savedValue
        });
            
    }
}

export default MoveAutomationBreakPointAction;
